module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"CONFIRM":"Confirmar","CANCEL":"Cancelar","DEFAULT-TITLE":"Confirmar ação"},"en-US":{"CONFIRM":"Confirm","CANCEL":"Cancel","DEFAULT-TITLE":"Confirm action"}}')
  delete Component.options._Ctor
}
